exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3Qz89{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._2QDq1{margin-bottom:15px!important}._2woFY{padding:10px 35px 10px 10px}._2woFY,.NpkaG{height:40px;border-radius:2px;font-size:14px;border:1px solid #aaa;background-color:#fff;color:#484848;font-weight:400}.NpkaG{padding:10px 32px 10px 10px}.eQO-d{position:relative;display:inline-block;vertical-align:bottom;margin-right:5px}.xu6gV{overflow:hidden}._3NRLZ{max-width:350px}.s8gxp{padding:0}._3veaG,.Dt5_l{margin-bottom:12px}.hCj4X{margin-bottom:18px}._1kA8t{font-size:15px;color:#767676;margin:6px 0;line-height:1.43;font-weight:400}._1Rzyx{margin-right:10px}._39M9b{float:right}._3mwoe{text-align:right}._1LYMi{text-align:left}.ZZEbE{color:#008489}._29_pZ{font-size:16px;line-height:32px}.ZZEbE:focus,.ZZEbE:hover{color:#008489;text-decoration:underline}._29tjF{box-sizing:border-box;margin:0;width:auto;outline:0;border:1px solid #373277;border-radius:4px;background:#373277;color:#fff;text-align:center;text-decoration:none;font-size:16px;line-height:1.3333333;cursor:pointer}._29tjF:hover{background:rgba(54,50,119,.8)}._29tjF:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}._1kAY7{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._1kAY7:disabled:focus,._1kAY7:disabled:hover,._1kAY7:focus,._1kAY7:hover{border-color:#ff7e82;background-color:#ff7e82;color:#fff}.q9b7r{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}.q9b7r:focus,.q9b7r:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}.TsTmw{padding:5px 0}._2aCs5{padding:7px 21px}._2ERkW{position:relative;z-index:1;display:block;margin:15px 0;width:100%;color:#767676;text-align:center;font-size:14px}._1_br7,._1x7Nt,._2QDq1 ._3aF6p{border:1px solid #aaa}._1_br7{padding:15px;border-radius:2px}._2FJhD{margin-right:15px}._15V77{display:inline-block}", ""]);

// exports
exports.locals = {
	"errorMessage": "_3Qz89",
	"formGroup": "_2QDq1",
	"formControlInput": "_2woFY",
	"formControlSelect": "NpkaG",
	"select": "eQO-d",
	"formSection": "xu6gV",
	"formMaxWidth": "_3NRLZ",
	"noPadding": "s8gxp",
	"space1": "_3veaG",
	"space2": "Dt5_l",
	"space3": "hCj4X",
	"labelText": "_1kA8t",
	"btnRight": "_1Rzyx",
	"btnAlignRight": "_39M9b",
	"textAlignRight": "_3mwoe",
	"textAlignLeft": "_1LYMi",
	"modalCaptionLink": "ZZEbE",
	"modalCaptionLinkLarge": "_29_pZ",
	"button": "_29tjF",
	"btnPrimary": "_1kAY7",
	"btnPrimaryBorder": "q9b7r",
	"btnSmall": "TsTmw",
	"btnLarge": "_2aCs5",
	"horizontalLineThrough": "_2ERkW",
	"input-group-addon": "_3aF6p",
	"inputGroupAddon": "_1x7Nt",
	"formContainer": "_1_br7",
	"marginRight": "_2FJhD",
	"btnContainer": "_15V77"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/PhoneVerificationModal/VerifyPhoneNumberForm/VerifyPhoneNumberForm.css
// module id = 2554
// module chunks = 15